import React, { useEffect, useRef } from "react";

function QuillEditor({ value, onChange, placeholder = "" }) {

    const editorRef = useRef(null);
    const quillRef = useRef(null);

    useEffect(() => {

        if (!editorRef.current || !window.Quill) return;

        if (!quillRef.current) {

            quillRef.current = new window.Quill(editorRef.current, {
                theme: "snow",
                placeholder: placeholder,

                modules: {
                    toolbar: [
                        [{ header: [1, 2, 3, false] }],
                        ["bold", "italic", "underline", "strike"],
                        [{ color: [] }, { background: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ align: [] }],
                        ["link"],
                        ["clean"]
                    ]
                }
            });

            quillRef.current.on("text-change", () => {

                const html = quillRef.current.root.innerHTML;

                onChange(html);
            });
        }

        if (
            value &&
            value !== quillRef.current.root.innerHTML
        ) {
            quillRef.current.root.innerHTML = value;
        }

    }, [value, onChange, placeholder]);

    return (
        <div ref={editorRef}></div>
    );
}

export default QuillEditor;